import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children, activeFilterLabel = 0 }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  return (
    <x-modal data-id={`filter-${id}`} className="flex flex-col border-b group/filter border-brand-pink">
      <button
        data-modal-role="toggle"
        aria-label="Toggle Filter"
        type="button"
        data-modal-parent={`filter-${id}`}
        className="flex items-center justify-between w-full h-12 paragraph-md"
      >
        <span>{label}</span>
        <div className={'flex items-center gap-1'}>
          {activeFilterLabel !== 0 && (
            <span className="text-neutral-secondary">({activeFilterLabel})</span>
          )}
          <Icon id="chevron-down" className="group-data-visible/filter:hidden" />
          <Icon id="minus" className="hidden group-data-visible/filter:block" />
        </div>

      </button>
      <div className="flex flex-col overflow-hidden transition-all max-h-0 group-data-visible/filter:max-h-96">
        {children}
      </div>
    </x-modal>
  )
}
